import * as actionTypes from './types';

const inituelState = {
    loading: false,
    error: false,
    
    propertyTypes: null
};
const propertyTypeReducer = (state = { ...inituelState }, action) => {
    const payload = action.payload;
    switch (action.type) {
        case actionTypes.REQUST_PROPERTY_TYPE:
            return {
                ...state,
                loading: true
            };
        case actionTypes.FAILED_PROPERTY_TYPE:
            return {
                ...state,
                loading: false,
                error: payload
            };
        case actionTypes.SUCCESS_PROPERTY_TYPE:
            return {
                ...state,
                ...payload,
                loading: false,
                error: false
            };

      
        default:
            return {
                ...state
            };
    }
};

export default propertyTypeReducer;
